import type { ProjectRef } from '@volley/crucible-ipc-types';

interface RouteLocation {
  readonly hash: string;
  readonly pathname: string;
}

/** True only while the renderer is still on the placement-qualified workspace route. */
export function isProjectWorkspaceRouteActive(
  project: ProjectRef,
  location: RouteLocation = window.location,
): boolean {
  const route = location.hash.startsWith('#/') ? location.hash.slice(1) : location.pathname;
  const match = /^\/workspace\/(local|cloud)\/([^/?#]+)(?:[/?#]|$)/.exec(route);
  if (!match) return false;
  try {
    return match[1] === project.placement && decodeURIComponent(match[2]!) === project.gameId;
  } catch {
    return false;
  }
}
